import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";
import {
  IBankTransferResponse,
  PaymentBrand,
} from "../../../setup/api/services/payment/models";
import { makeBankTransfer } from "../../../setup/api/services/payment";
import { uploadFile } from "../../../s3Integration/s3Client";
import { EUploadImageType } from "../../../s3Integration/enums";
import { PartyRow } from "../create/partyTable";

export const submitBankTransfer = async (
  images: File[],
  contract: IContractDetailsResponseData,
  customerRow: PartyRow,
  beneficiaryId: string,
  beneficiaryName: string,
  gatewayPaymentId: string
): Promise<IBankTransferResponse> => {
  const urls = await Promise.all(
    images.map((file) =>
      uploadFile(file, EUploadImageType.CONTRACT, contract.id)
    )
  );

  return makeBankTransfer({
    version: contract.version ?? 0,
    domainId: contract.shortId ?? "",
    domainType: "CONTRACT",
    paymentType: "MANUAL_BANK_TRANSFER",
    connector: "MANUAL_BANK_TRANSFER",
    paymentBrand: PaymentBrand.BANK_TRANSFER,
    currency: "SAR",
    amount: Number(customerRow.amount),
    beneficiaryId,
    beneficiaryName,
    fromUserId: Number(customerRow.id),
    fromUserName: customerRow.name,
    bankTransferPaymentInfo: { docs: urls },
    gatewayPaymentId,
  });
};
